import { colorConstants } from 'config/colorConstants';

export const PieChartIcon = ({
    color = colorConstants.yellow,
}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M21.21 15.8901C19.4598 20.029 15.1638 22.4921 10.7077 21.9116C6.25168 21.3311 2.7301 17.8495 2.09874 13.4004C1.46738 8.95125 3.88133 4.62738 7.99995 2.83008" stroke="#EFB306" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path d="M22 12C22 6.48085 17.5192 2 12 2V12H22" stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
);

export default PieChartIcon;
